import {LoggerLevel} from '../services';

interface AppConfig {
    apiConfig: ApiConfig;
    localeConfig?: LocaleConfig;
    logLevel?: LoggerLevel;
}

class ApiConfig {
    API_URL: string;
}

const API_CONFIG = {
    API_URL: ''
};

class LocaleConfig {
    DEFAULT_LANGUAGE: string;
    DEFAULT_LOCALE: string;
    SECTION: string;
}

const LOCALE_CONFIG = {
    DEFAULT_LANGUAGE: 'en',
    DEFAULT_LOCALE: 'en-EN',
    SECTION: 'webconfigurator'
};

export {ApiConfig, API_CONFIG, LOCALE_CONFIG, LocaleConfig, AppConfig};




// WEBPACK FOOTER //
// ./src/app/common/utils/config.ts